import React from 'react'
import { Route, Switch } from "react-router-dom"
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Qs from 'query-string'
import Cookies from 'js-cookie'

import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'

import { logout } from '../actions/asyncMember'

import Header from './Header'
import Instruction from './Instruction'
import Setting from './Setting'
import WineList from './WineList'
import ShoppingCart from './shoppintcart/ShoppingCart'
import ShoppingCartPaymentPage from './shoppintcart/ShoppingCartPaymentPage'
import OrderList from './order/OrderList'
import OrderDetail from './order/OrderDetail'
import CouponList from './coupon/CouponList'
import PaymentComfirm from './common/PaymentComfirm'
import InboundList from './inbound/InboundList'
import InboundDetail from './inbound/InboundDetail'
import VerifyPhone from 'components/dialog/VerifyPhone'

const styles = theme => ({
	maxWidth: {
		[theme.breakpoints.up('lg')]: {
			width: 1220
		}
	}
})

const Member = props => {
	const { classes, memberInfo, logout } = props;
	const location = window.location
	if (!!location.search) {
		const search = Qs.parse(location.search);
		if (Cookies.get('memberSha') !== search.memberId) {
			logout()
		}
	}

	return (
			<Grid container justify="center">
				<Header />
				{!memberInfo.isPhoneVerified &&
					<VerifyPhone />
				}
				<Grid
					container
					className={classes.maxWidth}
					justify="center"
					style={{ marginTop: '64px' }}
				>
					<Switch>
						<Route exact path="/member/setting/:tabId" component={Setting} />
						<Route exact path="/member/wines" component={WineList} />
						<Route exact path="/member/shippingcart" component={ShoppingCart} />
						<Route exact path="/member/shippingcart/comfirm" component={ShoppingCartPaymentPage} />
						<Route exact path="/member/order" component={OrderList} />
						<Route exact path="/member/order/detail" component={OrderDetail} />
						<Route exact path="/member/coupon" component={CouponList} />
						<Route exact path="/member/inbound" component={InboundList} />
						<Route exact path="/member/inbound/detail" component={InboundDetail} />
						<Route exact path="/member/inbound/comfirm" component={PaymentComfirm} />
						<Route exact path="/" component={Instruction} />
						<Route exact path="/how-to-use" component={Instruction} />
					</Switch>
				</Grid>
			</Grid>
	)
}

export default connect(
	state => ({
		memberInfo: state.member.member,
	}),
	{ logout }
)(withStyles(styles)(Member))